import {axiosInstance, publicAxiosInstance} from "../utils/axios";

export const createTeacher = (teacher) => {
    return publicAxiosInstance.post('users/teacher', teacher);
};

export const updateTeacherProfile = ({id, data}) => {
    if (!id || !data)
        return;
    return axiosInstance.put(`teachers/${id}`, data)
}
